<template>
  <div>
    <el-table :data="data" style="width: 100%">
      <el-table-column label="序号" prop="index" width="80"></el-table-column>
      <el-table-column prop="tagName" label="标签名称"></el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="{ row }">
          <el-button size="mini" @click="handTagEdit(row)">编辑</el-button>
          <el-button size="mini" @click="handTagDelete(row)" type="danger"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  methods: {
    handTagEdit(row) {
      this.$emit('handTagEdit', row)
    },
    handTagDelete(row) {
      this.$emit('handTagDelete', row)
    }
  },
}
</script>
